import { render, staticRenderFns } from "./car-bottom.vue?vue&type=template&id=0b1c419c&scoped=true"
import script from "./car-bottom.vue?vue&type=script&lang=js"
export * from "./car-bottom.vue?vue&type=script&lang=js"
import style0 from "./car-bottom.vue?vue&type=style&index=0&id=0b1c419c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c419c",
  null
  
)

export default component.exports